import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { Mail, Lock, UserCircle2 } from 'lucide-react';
import { supabase } from '../lib/supabaseClient';
import logoPolimdo from '../assets/logo/logo-polimdo.png';

function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setLoading(true);

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      setErrorMsg(error.message);
      setLoading(false);
      return;
    }

    const authUser = data?.user;

    if (!authUser) {
      setErrorMsg('Sesi login tidak ditemukan.');
      setLoading(false);
      return;
    }

    const { data: profileData, error: profileError } = await supabase
      .schema('akreditasi')
      .from('profiles')
      .select('*')
      .eq('user_id', authUser.id)
      .maybeSingle();

    if (profileError) {
      setErrorMsg(`Gagal mengambil profile: ${profileError.message}`);
      setLoading(false);
      return;
    }

    if (!profileData) {
      setErrorMsg('Profile user belum ada di tabel profiles.');
      setLoading(false);
      return;
    }

    if (!profileData.is_active) {
      setErrorMsg('Akun ini nonaktif. Hubungi admin.');
      setLoading(false);
      return;
    }

    setLoading(false);

    if (profileData.role === 'superadmin') {
      navigate('/superadmin');
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="login-modern-shell">
      <div className="login-modern-card">
        <div className="login-left-panel-new">
          <div className="login-left-overlay" />

          <div className="login-left-content-new">
            <div className="login-logo-badge">
              <img src={logoPolimdo} alt="Logo Politeknik Negeri Manado" />
            </div>

            <h1 className="login-campus-title">Politeknik Negeri Manado</h1>
            <div className="login-campus-divider" />
            <h2 className="login-system-title">Sistem Informasi Akreditasi</h2>

            <p className="login-system-desc">
              Sistem informasi terintegrasi untuk mendukung proses pengelolaan data,
              monitoring, dan pelaporan akreditasi program studi dan institusi.
            </p>

            <div className="login-feature-grid">
              <div className="login-feature-item">
                <span>Aman</span>
                <small>dan terpercaya</small>
              </div>
              <div className="login-feature-item">
                <span>Terintegrasi</span>
                <small>dan akurat</small>
              </div>
              <div className="login-feature-item">
                <span>Mendukung</span>
                <small>akreditasi unggul</small>
              </div>
            </div>
          </div>
        </div>

        <div className="login-right-panel-new">
          <div className="login-form-card-new">
            <div className="login-icon-wrap">
              <UserCircle2 size={30} />
            </div>

            <h2 className="login-welcome-title">Selamat Datang</h2>
            <p className="login-welcome-subtitle">
              Silakan masuk untuk melanjutkan ke sistem
            </p>

            {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

            <Form onSubmit={handleLogin}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <div className="input-icon-wrap">
                  <Mail size={18} className="input-icon" />
                  <Form.Control
                    type="email"
                    placeholder="nama@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="login-input-modern"
                  />
                </div>
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Password</Form.Label>
                <div className="input-icon-wrap">
                  <Lock size={18} className="input-icon" />
                  <Form.Control
                    type="password"
                    placeholder="Masukkan password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className="login-input-modern"
                  />
                </div>
              </Form.Group>

              <Button type="submit" className="login-submit-btn" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Memproses...
                  </>
                ) : (
                  'Login'
                )}
              </Button>
            </Form>

            <a
              className="login-help-box"
              href="https://mail.google.com/mail/?view=cm&fs=1&to=hokkingtular69@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              <strong>Hubungi Admin</strong>
              <p>Jika mengalami kendala login atau akun belum aktif.</p>
            </a>
          </div>
        </div>
      </div>

      <div className="login-bottom-footer">
        Copyright 2025 Politeknik Negeri Manado - Kebijakan Privasi - Syarat & Ketentuan
      </div>
    </div>
  );
}

export default Login;
